"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactFocusOn = require("react-focus-on");

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var _propTypes = require("prop-types");

var _excluded = ["noMask", "inProp", "close"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ESCAPE_EVENT_KEY = 'Escape';

var FocusContainer = function FocusContainer(_ref) {
  var noMask = _ref.noMask,
      inProp = _ref.inProp,
      close = _ref.close,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _react.useEffect)(function () {
    // Without a mask, we need to handle the escape key manually.
    if (noMask) {
      var keydownHandler = function keydownHandler(evt) {
        if (evt.key === ESCAPE_EVENT_KEY) {
          close(evt);
        }
      };

      document.addEventListener('keydown', keydownHandler);
      return function () {
        return document.removeEventListener('keydown', keydownHandler);
      };
    }
  }, [noMask, close]);
  return !noMask ? /*#__PURE__*/_react["default"].createElement(_reactFocusOn.FocusOn, (0, _extends2["default"])({
    enabled: inProp,
    onClickOutside: !noMask ? close : null,
    onEscapeKey: close,
    returnFocus: true
  }, props)) : /*#__PURE__*/_react["default"].createElement(_reactFocusLock["default"], (0, _extends2["default"])({
    returnFocus: true
  }, props));
};

FocusContainer.propTypes = {
  noMask: _propTypes.bool,
  inProp: _propTypes.bool.isRequired,
  close: _propTypes.func.isRequired,
  autoFocus: _propTypes.bool
};
FocusContainer.defaultProps = {
  noMask: false,
  autoFocus: false
};
var _default = FocusContainer;
exports["default"] = _default;